import { UserProfileComponent } from "components"
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function Profile() {
    const { profileId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (profileId) {
            if (!profileId.startsWith("@")) {
                navigate("/");
                return;
            }
        }
    }, [profileId, navigate]);

    return (
        <div className="mobile:pb-[56px]">
            <UserProfileComponent profileId={profileId?.slice(1)!} />
        </div>
    )
}